import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import Statsig from 'statsig-js';

// Sidebar Service
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private menusSubject = new BehaviorSubject<Array<any>>([]);
  constructor() {}

  public getMenus(): any[] {
    return this.menusSubject.value;
  }

  public setMenus(menus: any) {
    this.menusSubject.next(menus);
  }

  public updateMenuWithFlag(
    menus: any[],
    mainTitle: string,
    flag: string,
    submenu: any
  ): any[] {
    if (Statsig.checkGate(flag)) {
      menus.forEach((menu) => {
        if (menu.activeUrl === mainTitle) {
          const submenuIndex = menu.submenus.findIndex(
            (sub: { title: any }) => sub.title === submenu.title
          );
          if (submenuIndex === -1) {
            menu.submenus.unshift({ ...submenu, activeUrl: menu.activeUrl });
          }
        }
      });

      menus.forEach((menu) => {
        if (menu.activeUrl === mainTitle) {
          menu.submenus.sort((a: { title: string }, b: { title: any }) =>
            a.title.localeCompare(b.title)
          );
        }
      });
    }
    this.menusSubject.next(menus);
    return menus;
  }

  public updateMenusBasedOnStatsigState(statsigUser: any): void {
    if (statsigUser) {
      const menus = this.getMenus();
      if (Statsig.checkGate('show_dashboard')) {
        if (!menus.find((value: any) => value.url === '/dashboard')) {
          menus.unshift({
            title: 'DASHBOARD',
            name: 'dashboard',
            url: '/dashboard',
            activeUrl: 'dashboard',
            icon: 'fa-gauge',
            icon2: '',
            submenus: [],
          });
        }
      }

      if (Statsig.checkGate('show_campaign')) {
        if (!menus.find((value: any) => value.url === '/campaign')) {
          menus.push({
            title: 'CAMPAIGN',
            name: 'campaign',
            url: '/campaign',
            activeUrl: '/campaign',
            icon: 'fa-bullhorn',
          });
        }
      }

      if (Statsig.checkGate('show_campaign_automation')) {
        if (!menus.find((value: any) => value.url === '/automation')) {
          menus.push( {
            title: 'AUTOMATION',
            name: 'automation',
            url: '/automation',
            activeUrl: '/automation',
            icon: 'fa-users-gear',
          });
        }
      }

      if (Statsig.checkGate('show_payoutengine')) {
        if (!menus.find((value: any) => value.url === '/payout-engine')) {
          menus.push({
            title: 'PAYOUT_ENGINE',
            name: 'payout-engine',
            url: '/payout-engine',
            activeUrl: '/payout-engine',
            icon: 'fa-money-bill-wave',
            icon2: '',
            disabled: false,
            submenus: [
              {
                title: 'PAYOUT_RULES',
                name: 'payout-rules',
                url: '/payout-engine/rules',
                activeUrl: '/payout-engine',
                icon: 'fa-cog',
                disabled: false,
              },
              {
                title: 'PAYOUT_PROFILES',
                name: 'payout-profiles',
                url: '/payout-engine/profiles',
                activeUrl: '/payout-engine',
                icon: 'fa-credit-card',
                disabled: false,
              },
              {
                title: 'PAYOUT_CYCLES',
                name: 'payout-cycles',
                url: '/payout-engine/cycles',
                activeUrl: '/payout-engine',
                icon: 'fa-sync',
                disabled: false,
              }
              // {
              //   title: 'DEBT_OBLIGATIONS',
              //   name: 'debt-obligations',
              //   url: '/payout-engine/obligations',
              //   activeUrl: '/payout-engine',
              //   icon: 'fa-file-invoice-dollar',
              //   disabled: false,
              // },
              // {
              //   title: 'PAYOUT_REPORTS',
              //   name: 'payout-reports',
              //   url: '/payout-engine/reports',
              //   activeUrl: '/payout-engine',
              //   icon: 'fa-chart-line',
              //   disabled: false,
              // }
            ]
          });
        }
      }

      this.menusSubject.next(menus);
    }
  }
}
